import React from 'react';
import { UIVoiceoverBtn } from '../components/composite';
import { InfoDL } from './InfoComponents';
import { renderCommonInfo, renderHighlights, generateSimulationContent } from './ContentRenderers';
import GTM from '../../_GTM';
import Utils from '../../_Utils';

export const generateCommonTabs = ({ type, data, lang, handleVOStateChange, getText, renderARButton, isVoiceoverEnabled }) => 
{
    const tabs = [];

    // Overview tab
    tabs.push({
        label: getText('overview'),
        className: 'overview',
        content: (
            <>
                {renderARButton && renderARButton()}
                {renderCommonInfo({ type, data, lang, handleVOStateChange, getText, isVoiceoverEnabled })}
            </>
        )
    });

    // Highlights tab (if available)
    const highlights = renderHighlights({ type, data, lang, handleVOStateChange, getText });
    if (highlights.length > 0) 
    {
        tabs.push({
            label: getText('highlights'),
            className: 'highlights',
            content: (
                <div className="highlights-content">
                    {data.highlights_filename && isVoiceoverEnabled() && (
                        <UIVoiceoverBtn 
                            lang={lang} 
                            filename={data.highlights_filename} 
                            onStateChange={() => handleVOStateChange(getText('highlights'))}
                        />
                    )}
                    {highlights}
                </div>
            )
        });
    }

    // Simulation tab (if available) - check if data has simulation
    if (data['has-simulation']) 
    {
        tabs.push({
            label: getText('simulation'),
            className: 'simulation',
            content: generateSimulationContent({ data, lang, getText })
        });
    }

    return tabs;
};

export const generateBFTabs = ({ data, lang, getText }) => 
{
    const tabs = [];

    // BF Info tab
    if (data.bf_access) 
    {
        tabs.push({
            label: getText('bf-info'),
            className: 'bf-info',
            content: (
                <div className="bf-info-content">
                    <InfoDL title={getText('bf-access-label')}>
                        {getText('bf-access' + data.bf_access)}
                    </InfoDL>
                    {data.bf_description && (
                        <div className="bf-description">
                            <div dangerouslySetInnerHTML={{ 
                                __html: Utils.markdownToHtml(data.bf_description) 
                            }} />
                        </div>
                    )}
                </div>
            )
        });
    }

    return tabs;
};

export const MapInfoTabsTatemono = ({ data, lang, renderARButton, getText, isVoiceoverEnabled }) =>
{
    const handleVOStateChange = (tab_name) => 
    {
        GTM.sendEvent('voiceover_play', 
        {
            content_group: 'map',
            lang: lang,
            page_type: 'site',
            page_name: data?.name || '',
            name: tab_name
        });
    }

    const commonTabs = generateCommonTabs({
        // Variables first
        data,
        lang,
        type: 'tatemono',
        getText,
        // Handlers last
        handleVOStateChange,
        renderARButton,
        isVoiceoverEnabled
    });

    const hasBFInfo = data?.bf_access || data?.bf_description;

    if (hasBFInfo) {
        commonTabs.push({
            label: getText('bf-info'),
            className: 'barrier-free',
            content: (
                <>
                    <div className="block info">
                        <InfoDL title={getText('bf-access-label')}>
                            {getText('bf-access' + data?.bf_access)}
                        </InfoDL>
                        {data?.bf_description && (
                            <div className="block text-block" 
                                dangerouslySetInnerHTML={{ 
                                    __html: Utils.markdownToHtml(data.bf_description) 
                                }} 
                            />
                        )}
                    </div>
                </>
            ),
        });
    }

    return commonTabs;
};

export const MapInfoTabsExterior = ({ data, lang, getText, isVoiceoverEnabled }) =>
{
    const handleVOStateChange = (tab_name) => {
        GTM.sendEvent('voiceover_play', {
            content_group: 'map',
            lang: lang,
            page_type: 'exterior',
            page_name: data?.name || '',
            name: tab_name
        });
    }

    return generateCommonTabs({
        // Variables first
        data,
        lang,
        type: 'exterior',
        getText,
        // Handlers last
        handleVOStateChange,
        renderARButton: null,
        isVoiceoverEnabled
    });
};

export const MapInfoTabsFood = ({ data, lang, getText, isVoiceoverEnabled }) =>
{
    const tabs = [
        {
            label: getText('overview'),
            className: 'overview',
            content: (
                <>
                    {data.is_construction && (
                        <div className="alert-message">
                            <p className="construction">
                                {getText('is-construction-cafe')}
                            </p>
                        </div>
                    )}
                    <div className="block dl-info">
                        <div className="block text-block">
                            <div dangerouslySetInnerHTML={{ 
                                __html: Utils.markdownToHtml(data.description || '') 
                            }} />
                        </div>
                    </div>
                    {data.description_filename && isVoiceoverEnabled() && (
                        <UIVoiceoverBtn lang={lang} filename={data.description_filename} />
                    )}
                </>
            ),
        },
    ];

    return tabs;
}; 